<template>
  <div class="webinar__loading" v-if="loading">
    <loading/>
  </div>
  <div class="webinar__loading" v-else-if="error">404</div>
  <webinar v-else-if="schedule.id || reallyArchived" :webinar="webinar"
           :schedule="schedule" :archived="reallyArchived"/>
</template>

<script lang="ts">
import {
  defineComponent, onMounted, PropType, ref,
} from 'vue'
import axios from 'axios'
import Webinar from '@/vue/public/Webinar.vue'
import Loading from '@/vue/public/Loading.vue'
import { Webinar as WebinarData, WebinarSchedule } from '@/types/webinar.d'
import Timeout from '@/types/timeout.d'

export default defineComponent({
  name: 'WebinarPage',
  components: {
    Loading,
    Webinar,
  },
  props: {
    webinar: Object as PropType<WebinarData | null>,
    archived: Boolean,
  },
  setup(props) {
    const loading = ref(true)
    const error = ref(false)

    const schedule = ref<WebinarSchedule>({
      id: 0,
      startAt: 0,
      endAt: 0,
      finished: false,
      left: 0,
    })

    const reallyArchived = ref(false)

    const checkArchived = async () => {
      const { data } = await axios.get(`/webinars/${props.webinar?.id}/is-archived`)
      reallyArchived.value = !!data.archived
    }

    let updateTimeout: Timeout
    const updateSchedule = async () => {
      clearTimeout(updateTimeout)
      if (props.webinar) {
        const scheduleId = localStorage.getItem(`webinar-${props.webinar.id}`)
        await axios.get(`/schedule/${props.webinar.id}`, { params: { scheduleId } })
          .then(({ data }) => {
            schedule.value = {
              id: +data.id,
              startAt: +data.startAt,
              endAt: +data.endAt,
              finished: !!data.finished,
              left: +data.left,
            }
            if (props.webinar) {
              localStorage.setItem(`webinar-${props.webinar.id}`, data.id)
            }
          })
          .catch(async () => {
            if (props.webinar?.archived) {
              schedule.value = {
                id: 0,
                startAt: 0,
                endAt: 0,
                finished: true,
                left: 0,
              }
              await checkArchived()
            } else {
              error.value = true
            }
          })
      }
      updateTimeout = setTimeout(updateSchedule, 5000)
    }

    onMounted(async () => {
      loading.value = true
      if (props.webinar) {
        if (props.archived) {
          await checkArchived()
        } else {
          await updateSchedule()
        }
      } else {
        error.value = true
      }
      loading.value = false
    })

    return {
      loading,
      error,
      schedule,
      reallyArchived,
    }
  },
})
</script>
